// pages/Home.js
import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Contact from '../components/Contact';
import StructuredData from '../components/StructuredData'; // Import the new component

function Home() {
  return (
    <>
      <StructuredData /> {/* Add structured data */}
      <Hero />
      <Services />
      <About />
      <Contact />
    </>
  );
}

export default Home;